import { Link } from "react-router-dom";

export function Logo({ size = 40, showText = true, className = "" }) {
  return (
    <Link to="/" data-testid="header-brand-logo" className={`flex items-center gap-3 ${className}`}>
      <img
        src="/rav3-logo.png"
        alt="Rav3.Labs-Studio"
        style={{ width: size, height: size }}
        className="logo-spin rounded-full object-cover ring-1 ring-[#E8552A]/40 shrink-0"
      />
      {showText && (
        <div className="leading-none">
          <div className="font-display font-extrabold text-[#F4F4F5] tracking-tight" style={{ fontSize: size * 0.4 }}>
            RAV3<span className="text-[#E8552A]">.LABS</span>
          </div>
          <div className="mono-label text-[#71717A]" style={{ fontSize: size * 0.17 }}>
            STUDIO · BANGALORE
          </div>
        </div>
      )}
    </Link>
  );
}

export function EqBars({ playing = true }) {
  return (
    <div className="flex items-end gap-[2px] h-4">
      {[0, 1, 2, 3, 4].map((i) => (
        <span
          key={i}
          className="eq-bar"
          style={{ animationDelay: `${i * 0.12}s`, animationPlayState: playing ? "running" : "paused", height: playing ? undefined : "20%" }}
        />
      ))}
    </div>
  );
}
